import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'default' | 'primary' | 'ghost';
  children: ReactNode;
}

export function Button({ variant = 'default', children, ...rest }: ButtonProps) {
  return (
    <button className="lc-btn" data-variant={variant} {...rest}>
      {children}
    </button>
  );
}
